const Z = {
  ONE:   0,
  TWO:   100,
  THREE: 1000,
};


/**
 * The z-index values for all of the app's pieces, arranged into 3 layers:
 *   * ONE: The page's base content
 *   * TWO: Floating content above the main content i.e. modals
 *   * THREE: Accessory views that float above everything e.g. tooltips/Snackbars
 *
 * Add to this map as you add z-index styles to the app.
 * Do not repurpose an unrelated z-index value!
 * Do not use a value literal in place of adding a new value here!
 */
export const LAYER = {
  ONE:   {
    MAIN_CONTENT: Z.ONE + 1,
    FACE_GUIDE:   Z.ONE + 1,
  },
  TWO:   {
    BLOCKING_LOADER: Z.TWO,
    MODAL_BASE:      Z.TWO + 1,
  },
  THREE: {
    SNACKBAR:         Z.THREE,
    FLOATING_CONTENT: Z.THREE + 1,
  },
};
